// extracted by mini-css-extract-plugin
module.exports = {"whatsappFloat":"WhatsappFloat_whatsappFloat__vG4bz"};